import { SelectTree } from 'react-viewerbase';
import React, { Component } from 'react';

import LabellingTransition from './LabellingTransition.js';
import PropTypes from 'prop-types';
import bounding from '../../lib/utils/bounding.js';
import cloneDeep from 'lodash.clonedeep';
import { getAddLabelButtonStyle } from './labellingPositionUtils.js';

import OHIF from 'ohif-core';

export default class LabellingFlow extends Component {
  static propTypes = {
    eventData: PropTypes.object.isRequired,
    measurementData: PropTypes.object.isRequired,
    annoLabels: PropTypes.array.isRequired,

    labellingDoneCallback: PropTypes.func.isRequired,
    updateLabelling: PropTypes.func.isRequired,

    skipAddLabelButton: PropTypes.bool,
    editLocation: PropTypes.bool,
    editDescription: PropTypes.bool,
    componentStyle: PropTypes.object,
  };

  static defaultProps = {
    annoLabels: [],
  };

  constructor(props) {
    super(props);

    const { location, locationCode, description } = props.measurementData;

    let style = props.componentStyle;
    if (!props.skipAddLabelButton) {
      style = getAddLabelButtonStyle(props.measurementData, props.eventData);
    }

    this.state = {
      location,
      locationCode,
      description,
      skipAddLabelButton: props.skipAddLabelButton,
      editDescription: props.editDescription,
      editLocation: props.editLocation,
      componentStyle: style,
      confirmationState: false,
      displayComponent: true,
    };

    this.mainElement = React.createRef();
    OHIF.log.info(this.mainElement);
    this.descriptionInput = React.createRef();

    this.initialItems = this.getTagList();
    this.currentItems = cloneDeep(this.initialItems);
  }

  // 获取标签列表
  getTagList = () => {
    return this.props.annoLabels.map(l => ({
      label: l.dictName,
      value: l.dictCode + '-' + l.dictVal,
    }));
  };

  componentDidUpdate = () => {
    this.repositionComponent();
  };

  render() {
    let mainElementClassName = 'labellingComponent';
    if (this.state.editDescription) {
      mainElementClassName += ' editDescription';
    }

    const style = Object.assign({}, this.state.componentStyle);
    if (this.state.skipAddLabelButton) {
      style.left -= 160;
    }

    return (
      <LabellingTransition
        displayComponent={this.state.displayComponent}
        onTransitionExit={this.props.labellingDoneCallback}
      >
        <div
          className={mainElementClassName}
          style={style}
          ref={this.mainElement}
          onMouseLeave={this.fadeOutAndLeave}
          onMouseEnter={this.clearFadeOutTimer}
        >
          {this.labellingStateFragment()}
        </div>
      </LabellingTransition>
    );
  }

  labellingStateFragment = () => {
    const {
      skipAddLabelButton,
      editLocation,
      // description,
      locationCode,
    } = this.state;

    if (!skipAddLabelButton) {
      return (
        <button
          type="button"
          className="addLabelButton"
          onClick={this.showLabelling}
        >
          {this.state.location ? '修改' : '新增'} 标签
        </button>
      );
    } else {
      if (editLocation) {
        return (
          <SelectTree
            items={this.currentItems}
            selectedCode={locationCode}
            columns={1}
            onSelected={this.selectTreeSelectCalback}
            selectTreeFirstTitle="选择标签"
            onComponentChange={this.repositionComponent}
            onClosed={this.closeTree}
            autoFocus={false}
            searchEnabled={false}
          />
        );
      }
    }
  };

  relabel = () => {
    this.setState({ editLocation: true });
  };

  setDescriptionUpdateMode = () => {
    this.descriptionInput.current.focus();

    this.setState({ editDescription: true });
  };

  descriptionCancel = () => {
    const { description = '' } = cloneDeep(this.state);
    this.descriptionInput.current.value = description;

    this.setState({ editDescription: false });
  };

  selectTreeSelectCalback = (event, codesSelected) => {
    const location = this.currentItems
      .filter(item => codesSelected.includes(item.value))
      .map(item => item.label)
      .join(',');
    const locationCode = codesSelected.join(',');
    this.props.updateLabelling({ location, locationCode });

    OHIF.log.info(this.mainElement);
    const viewportTopPosition = this.mainElement.current.offsetParent.offsetTop;
    const componentStyle = {
      top: event.nativeEvent.y - viewportTopPosition - 25,
      left: this.state.componentStyle.left,
    };

    this.setState({
      editLocation: false,
      confirmationState: true,
      location,
      locationCode,
      componentStyle,
      displayComponent: false,
    });
  };

  showLabelling = () => {
    this.setState({ skipAddLabelButton: true, editLocation: true });
  };

  fadeOutAndLeave = () => {
    // Wait for 1 sec to dismiss the labelling component
    this.fadeOutTimer = setTimeout(() => {
      this.setState({ displayComponent: false });
    }, 1000);
  };

  clearFadeOutTimer = () => {
    if (!this.fadeOutTimer) {
      return;
    }

    clearTimeout(this.fadeOutTimer);
  };

  closeTree = () => {
    this.setState({ displayComponent: false });
  };

  repositionComponent = () => {
    // SetTimeout for the css animation to end.
    setTimeout(() => {
      bounding(this.mainElement);
    }, 200);
  };
}
